export default "__VITE_ASSET__CDoD8IXU__"